module.exports = __webpack_public_path__ + "static/media/picasso-6.3f2908e9.jpeg";